// Thin, safe wrapper around the Meta Pixel (window.fbq).
// Pass an eventId to de-duplicate against the server-side Conversions API event.
export const track = (event, params, eventId) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    if (eventId) window.fbq("track", event, params || {}, { eventID: eventId });
    else window.fbq("track", event, params || undefined);
  }
};
